import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const FixedPoleFlatOriginal = () => {
  console.log('🎯 FixedPoleFlatOriginal component loading');
  
  const product = findProductById("fixed-pole-flat-original");
  
  if (!product) {
    console.error('Product not found:', "fixed-pole-flat-original");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="fixed-pole-flat-original"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default FixedPoleFlatOriginal; 